import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Left: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowWall2Left"><Path fillRule="evenodd" clipRule="evenodd" d="M5 4V12V20H3V4H5ZM8.41422 11L11.6642 7.75L10.25 6.33579L5.29289 11.2929C5.10536 11.4804 5 11.7348 5 12C5 12.2652 5.10536 12.5196 5.29289 12.7071L10.25 17.6642L11.6642 16.25L8.41421 13H21V11H8.41422Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWall2Left;
